import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ViewTradeLicence = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main_title">
        <h1>View License</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/license")}>License</button> -
          View License
        </p>
      </div>
      <div className="cards">
      
        <form className="form wrap_viewDemo_steps ">
          <div className="gap_p">
            <div className="control_group w_50">
              <label htmlFor="icon-button-file">Trade License Document</label>
              <div className="upload_box">
                <label className="upload_action" style={{ height: "200px" }}>
                  <input type="file" />

                  <img
                    style={{ objectFit: "contain", height: "100%" }}
                    src="/static/images/placeholder.png"
                    alt="icon"
                  />
                </label>
              </div>
            </div>
            <div className="control_group w_50">
              <label htmlFor="icon-button-file">
                Memorandum of Association (MOA)(Optional){" "}
              </label>
              <div className="upload_box">
                <label className="upload_action" style={{ height: "200px" }}>
                  <input type="file" />

                  <img
                    style={{ objectFit: "contain", height: "100%" }}
                    src="/static/images/placeholder.png"
                    alt="icon"
                  />
                </label>
              </div>
            </div>
          
          </div>
        </form>
      </div>
     
    </>
  );
};
export default ViewTradeLicence;
